export default __webpack_public_path__ + "static/media/tablet.193b113a.png";